export const formatName = (name: string = "") => {
    const nameParts = name.trim().split(' ');
    if (nameParts.length === 1) {
      return name;
    }
    const lastNameInitial = nameParts[nameParts.length - 1].charAt(0);
    return `${nameParts.slice(0, -1).join(' ')} ${lastNameInitial}`;
  }